// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Gpfg","bigColWidth":"Table_bigColWidth__1LfIc","biggerColWidth":"Table_biggerColWidth__T8AXh","row":"Table_row__2JiQ6","col":"Table_col__zNGaC"};